import { FIELD_PATHS } from '@funnels/constants';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { CheckboxField } from '../../../Fields';

export const UnderstandsSecurityGuarantee = ({
  brokerInterviewsGuarantorIndex,
}: BrokerInterviewsGuarantorEntityIndex) => {
  return (
    <FunnelGrid mt="xs" mb="lg">
      <FunnelGridUnit size={1 / 2}>
        Do you understand that should the borrower be unable to meet the commitments of the loan or fails to meet those
        commitments for any reason, you may be required to pay the guaranteed amount?
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <CheckboxField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_SECURITY_GUARANTEE(brokerInterviewsGuarantorIndex)}
          checkboxLabel="The guarantor understands and wants to proceed"
          size="sm"
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
